import {
  Button,
  Paper,
  TextField,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import axios from "../../config/authaxios";
import Dropdown from "../../css/dropdown.module.scss";
import { IconButton, Typography, Chip, Autocomplete, Avatar, Divider, CircularProgress, Checkbox, FormControlLabel } from "@mui/material";
import DeleteIcon from "@mui/icons-material/Delete";
import RestoreFromTrashIcon from "@mui/icons-material/RestoreFromTrash";
import {
  CASHBACK_ALLOWED_OPTIONS,
  getCashbackAllowedLabel,
} from "../../constants/cashbackAllowed";
import Modal from "@mui/material/Modal";
import Box from "@mui/material/Box";
import { useNavigate } from 'react-router-dom';

const style = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: 400,
  bgcolor: "background.paper",
  border: "2px solid #000",
  boxShadow: 24,
  p: 4,
};

const publisherHeaderCellSx = {
  bgcolor: "#DC8449",
  color: "#fff",
  fontWeight: 600,
  whiteSpace: "nowrap",
};

function Publihser() {
  const [coupons, setCoupons] = useState([]);
  const [page, setPage] = useState(0);
  const [limit, setLimit] = useState(10);
  const [isVerified, setIsVerified] = useState(true);
  const [isMore, setIsMore] = useState(false);
  const [nodata, setNodata] = useState(false);
  const [open, setOpen] = useState(false);
  const [openCashback, setOpenCashback] = useState(false);
  const [openDefaultVoucherList, setOpenDefaultVoucherList] = useState(false);
  const [isPublisherId, setIsPublisherId] = useState();
  const [mobileStatus, setMobileStatus] = useState(false);
  const [defaultVoucherListStatus, setDefaultVoucherListStatus] = useState(false);
  const [cashbackAllowedType, setCashbackAllowedType] = useState(0);
  const [openRegister, setOpenRegister] = useState(false);
  const [openPassword, setOpenPassword] = useState(false);
  const [openCategory, setOpenCategory] = useState(false);
  const [openLinkCategory, setOpenLinkCategory] = useState(false);
  const [linkCategoryPublisherId, setLinkCategoryPublisherId] = useState("");
  const [linkCategoryForm, setLinkCategoryForm] = useState({
    name: "",
    position: "",
    cashback_percentage: "",
    image: "",
    is_popular_category: false,
  });
  const emptyLinkCategoryForm = {
    name: "",
    position: "",
    cashback_percentage: "",
    image: "",
    is_popular_category: false,
  };
  const [editingCategoryId, setEditingCategoryId] = useState(null);
  const [linkCategoryIsDeleted, setLinkCategoryIsDeleted] = useState(false);
  const [publisherCategories, setPublisherCategories] = useState([]);
  const [loadingPublisherCategories, setLoadingPublisherCategories] = useState(false);
  const [selectedCategories, setSelectedCategories] = useState([]);
  const [selectedPublisher, setSelectedPublisherId] = useState("");
  const [categories, setCategories] = useState([
    { _id: 1, name: "Qwick Cilver" },
    { _id: 2, name: "Khiladi Adda" },
    { _id: 3, name: "Google Play" },
    { _id: 4, name: "Therewards" },
    { _id: 5, name:"Hubble"}
  ]);


  const [formData, setFormData] = useState({
    name: "",
    email: "",
    mobile: "",
    // app_key: "",
    // secret_key: "",
    password: "",
    c_password: "",
  });
  const navigate = useNavigate();

  const [changePasswordData, setChangePasswordData] = useState({
    email: "",
    password: "",
    c_password: "",
  });

  const fetchPublishers = () => {
    setPage(0);
    setNodata(true);
    setIsMore(false);

    axios.get(`/admin/publishers/0/10/${isVerified}/false`).then((res) => {
      if (res.data.status_code == 401) {
        localStorage.clear();
      }
      let data = Array.isArray(res.data.response) ? res.data.response : [];
      if (res.data.status) {
        setCoupons(data);
        if (data && data.length < limit) {
          setIsMore(true);
        }
        if (data.length === 0) {
          setNodata(true);
        } else {
          setNodata(false);
        }
        setPage(1);
      }
    });
  };

  const verfiyHandler = async () => {
    axios
      .post(`admin/publisher/verify`, {
        profit_margin: 1,
        publisher_id: isPublisherId,
      })
      .then((res) => {
        if (res.data.status_code == 401) {
          localStorage.clear();
        }
        let data = res.data.response;
        console.log(data);
        if (res.data.status) {
          alert(res.data.message);
          setOpen(false);
          setCoupons([]);
          fetchPublishers();
        }
      });
  };

  const changeMobileRequreStaus = async () => {
    axios
      .post(`/admin/changeMobileRequireStatus`, {
        publisher_id: isPublisherId,
        is_mobile: mobileStatus,
      })
      .then((res) => {
        if (res.data.status_code == 401) {
          localStorage.clear();
        }
        let data = res.data.response;
        console.log(data);
        if (res.data.status) {
          alert(res.data.message);
          setOpen(false);
          setCoupons([]);
          fetchPublishers();
        }
      });
  };

  const changeCashbackAllowedType = async () => {
    axios
      .post(`/admin/changeCashbackAllowedType`, {
        publisher_id: isPublisherId,
        cashback_allowed_type: cashbackAllowedType,
      })
      .then((res) => {
        if (res.data.status_code == 401) {
          localStorage.clear();
        }
        if (res.data.status) {
          const updated = res.data.response;
          alert(
            res.data.message ||
              "Publisher cashback allowed type updated successfully."
          );
          setOpenCashback(false);
          setCoupons((prev) =>
            prev.map((publisher) =>
              publisher._id === isPublisherId
                ? {
                    ...publisher,
                    cashback_allowed_type: updated?.cashback_allowed_type,
                    cashback_allowed_label: updated?.cashback_allowed_label,
                  }
                : publisher
            )
          );
        } else {
          alert(res.data.message || "Failed to update cashback allowed type.");
        }
      })
      .catch((err) => {
        alert(
          err?.response?.data?.message ||
            "Failed to update cashback allowed type."
        );
      });
  };

  const changeDefaultVoucherList = async () => {
    axios
      .post(`/admin/changeDefaultVoucherList`, {
        publisher_id: isPublisherId,
        is_default_voucher_list: defaultVoucherListStatus,
      })
      .then((res) => {
        if (res.data.status_code == 401) {
          localStorage.clear();
        }
        if (res.data.status) {
          const updated = res.data.response;
          alert(res.data.message || "Voucher list type updated successfully.");
          setOpenDefaultVoucherList(false);
          setCoupons((prev) =>
            prev.map((publisher) =>
              publisher._id === isPublisherId
                ? {
                    ...publisher,
                    is_default_voucher_list:
                      updated?.is_default_voucher_list ??
                      defaultVoucherListStatus,
                  }
                : publisher
            )
          );
        } else {
          alert(res.data.message || "Failed to update default voucher list.");
        }
      })
      .catch((err) => {
        alert(
          err?.response?.data?.message ||
            "Failed to update default voucher list."
        );
      });
  };

  useEffect(() => {
    fetchPublishers();
    return () => {
      setCoupons([]);
    };
  }, []);

  const Showmore = () => {
    setNodata(true);
    setIsMore(false);
    let temp = "?";

    if (page === 0 || page) {
      temp += "page=" + page + "&";
    }

    if (limit) {
      temp += "limit=" + limit + "&";
    }
    axios.get(`/admin/coupons-list${temp}`).then((res) => {
      if (res.data.status_code == 401) {
        localStorage.clear();
      }
      let data = res.data.response;
      if (Object.keys(data).length === 0) {
        setNodata(false);
        setIsMore(true);
      }
      const nextRows = [
        ...coupons,
        ...(Array.isArray(data) ? data : []),
      ];
      let temp = nextRows;

      if (data.length < limit) {
        setIsMore(true);
      }
      setCoupons(temp);
      setNodata(false);
      setPage(page + 1);
    });
  };
  const handleChange = (e) => {
    setFormData({
      ...formData,
      [e.target.name]: e.target.value,
    });
  };

  const handleSubmit = () => {
    if (
      !formData?.name ||
      !formData?.email ||
      !formData?.mobile ||
      !formData?.password ||
      !formData?.c_password
    ) {
      alert("Please Enter All Field Value");
      return;
    }

    if (formData?.password != formData?.c_password) {
      alert("Password and Confirm Password Not Matched");
      return;
    }
    setOpenRegister(false);

    axios
      .post(`/publishers/api/register`, formData)
      .then((res) => {
        console.log("res password Change", res);
        alert(res?.data?.message)
      })
      .catch((error) => {
        console.log("error in Adding publisher", error);
      });
  };

  const handleChangePassWord = () => {
    if (
      !changePasswordData?.email ||
      !changePasswordData?.password ||
      !changePasswordData?.c_password
    ) {
      alert("Please Enter All Field Value");
      return;
    }

    if (changePasswordData?.password != changePasswordData?.c_password) {
      alert("Password and Confirm Password Not Matched");
      return;
    }
    setOpenPassword(false);
    axios
      .post(`/publishers/api/handleChangePublisherPassword`, changePasswordData)
      .then((res) => {
        console.log("res for adding publisher", res);
        alert(res?.data?.message)
        setChangePasswordData({
          email: "",
          password: "",
          c_password: "",
        })
      })
      .catch((error) => {
        console.log("error in Password Changing", error);
      });

  }

  const fetchPublisherCategories = (
    publisherId,
    isDeleted = linkCategoryIsDeleted
  ) => {
    setLoadingPublisherCategories(true);
    axios
      .get(`/admin/publisher/categories/${publisherId}/${isDeleted}`)
      .then((res) => {
        if (res.data.status_code == 401) {
          localStorage.clear();
        }
        if (res.data.status) {
          setPublisherCategories(res.data.response || res.data.data || []);
        } else {
          setPublisherCategories([]);
        }
      })
      .catch((err) => {
        console.error("Error fetching publisher categories:", err);
        setPublisherCategories([]);
      })
      .finally(() => {
        setLoadingPublisherCategories(false);
      });
  };

  const handleDeleteOrRestorePublisherCategory = (category, isDeleted) => {
    axios
      .delete(`/admin/publisher/category/delete`, {
        data: {
          category_id: category._id,
          is_deleted: isDeleted,
        },
      })
      .then((res) => {
        if (res.data.status_code == 401) {
          localStorage.clear();
        }
        alert(
          res?.data?.message ||
            (isDeleted
              ? "Category deleted successfully"
              : "Category restored successfully")
        );
        if (res.data.status) {
          if (editingCategoryId === category._id) {
            resetLinkCategoryForm();
          }
          fetchPublisherCategories(linkCategoryPublisherId, linkCategoryIsDeleted);
        }
      })
      .catch((err) => {
        alert(
          err?.response?.data?.message ||
            (isDeleted
              ? "Failed to delete category."
              : "Failed to restore category.")
        );
      });
  };

  const handleLinkCategoryImageUpload = (e) => {
    const file = e.target.files?.[0];
    if (!file) return;

    const Dataform = new FormData();
    Dataform.append("file", file);
    const FileSize = Number(file.size / 1000);
    const _URL = window.URL || window.webkitURL;
    const img = new Image();

    img.onload = function () {
      axios.post(`/admin/upload-image`, Dataform).then((res) => {
        const url = res?.data?.Image?.url;
        if (!url) {
          alert("Image upload failed: server did not return an image URL.");
          return;
        }
        setLinkCategoryForm((prev) => ({
          ...prev,
          image: url,
        }));
        alert(`Image is Successfully Uploaded, Your file size is ${FileSize}`);
      }).catch((err) => {
        alert(err?.response?.data?.message || "Image upload failed.");
      });
    };
    img.onerror = function () {
      alert("not a valid file: " + file.type);
    };
    img.src = _URL.createObjectURL(file);
  };

  const resetLinkCategoryForm = () => {
    setLinkCategoryForm(emptyLinkCategoryForm);
    setEditingCategoryId(null);
  };

  const handleEditPublisherCategory = (category) => {
    setEditingCategoryId(category._id);
    setLinkCategoryForm({
      name: category.name || "",
      position: category.position ?? "",
      cashback_percentage: category.cashback_percentage ?? "",
      image: category.image || "",
      is_popular_category: !!category.is_popular_category,
    });
  };

  const handleCreatePublisherCategory = () => {
    if (!linkCategoryForm.name || linkCategoryForm.position === "") {
      alert("Please enter category name and position");
      return;
    }

    axios
      .post(`/admin/publisher/category`, {
        publisher_id: linkCategoryPublisherId,
        name: linkCategoryForm.name,
        position: Number(linkCategoryForm.position),
        cashback_percentage: Number(linkCategoryForm.cashback_percentage || 0),
        image: linkCategoryForm.image || "",
        is_popular_category: !!linkCategoryForm.is_popular_category,
      })
      .then((res) => {
        if (res.data.status_code == 401) {
          localStorage.clear();
        }
        alert(res?.data?.message || "Category created successfully!");
        if (res.data.status) {
          resetLinkCategoryForm();
          fetchPublisherCategories(linkCategoryPublisherId);
        }
      })
      .catch((err) => {
        alert(
          err?.response?.data?.message || "Failed to create publisher category."
        );
      });
  };

  const handleUpdatePublisherCategory = () => {
    if (!editingCategoryId) return;
    if (!linkCategoryForm.name || linkCategoryForm.position === "") {
      alert("Please enter category name and position");
      return;
    }

    axios
      .put(`/admin/publisher/category/update`, {
        category_id: editingCategoryId,
        name: linkCategoryForm.name,
        position: Number(linkCategoryForm.position),
        cashback_percentage: Number(linkCategoryForm.cashback_percentage || 0),
        image: linkCategoryForm.image || "",
        is_popular_category: !!linkCategoryForm.is_popular_category,
      })
      .then((res) => {
        if (res.data.status_code == 401) {
          localStorage.clear();
        }
        alert(res?.data?.message || "Category updated successfully!");
        if (res.data.status) {
          resetLinkCategoryForm();
          fetchPublisherCategories(linkCategoryPublisherId);
        }
      })
      .catch((err) => {
        alert(
          err?.response?.data?.message || "Failed to update publisher category."
        );
      });
  };

  const handleSubmitCategory = (selectedCategories) => {
    const categoryIds = selectedCategories.map(cat => cat._id);
    console.log("thisis the best way----------->")
    axios.post(`/admin/add/category/to/publisher`, {
      publisher_id: selectedPublisher,
      categories_id: categoryIds,
    })
      .then((res) => {
        alert(res?.data?.message || "Categories updated successfully!");
        setOpenCategory(false);
        fetchPublishers();
      })
      .catch((err) => {
        console.error("Error updating categories:", err);
      });
  };

  const handleClose = () => {
    setOpenPassword(false);
    setChangePasswordData({
      password: "",
      c_password: "",
    })
  }
  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: "12px",
  };

  const linkCategoryModalStyle = {
    ...style,
    width: 480,
    maxHeight: "90vh",
    overflowY: "auto",
  };

  return (
    <>
      <section>
        <section>
          <section style={{ width: "45%" }}>
            <div className={Dropdown.dropdown}>
              {coupons.length > 0 && !isMore && (
                <Button
                  variant="contained"
                  sx={{ ml: 1, my: 2 }}
                  color="info"
                  className={Dropdown.dropbtn}
                  onClick={Showmore}
                >
                  More
                </Button>
              )}
            </div>

            <div className={Dropdown.dropdown}>
              <Button
                variant="contained"
                sx={{ ml: 1, my: 2 }}
                color="info"
                className={Dropdown.dropbtn}
              >
                limit
              </Button>
              <div className={Dropdown.dropdown_content}>
                <a
                  className={limit === 25 ? "disabled" : "notDisabled"}
                  onClick={() => {
                    setLimit(25);
                    setPage(0);
                  }}
                >
                  25
                </a>
                <a
                  disabled={limit === 50 ? true : false}
                  onClick={() => {
                    setLimit(50);
                    setPage(0);
                  }}
                >
                  50
                </a>
                <a
                  disabled={limit === 100 ? true : false}
                  onClick={() => {
                    setLimit(100);
                    setPage(0);
                  }}
                >
                  100
                </a>
                <a
                  disabled={limit === 500 ? true : false}
                  onClick={() => {
                    setLimit(500);
                    setPage(0);
                  }}
                >
                  500
                </a>
                <a
                  disabled={limit === 1000 ? true : false}
                  onClick={() => {
                    setLimit(1000);
                    setPage(0);
                  }}
                >
                  1000
                </a>
              </div>
            </div>

            {/* <div className={Dropdown.dropdown}>
              <Button
                variant="contained"
                sx={{ ml: 1, my: 2 }}
                color="info"
                className={Dropdown.dropbtn}
              >
                Verified
              </Button>
              <div className={Dropdown.dropdown_content}>
                <a
                  onClick={() => {
                    setIsVerified(true);
                  }}
                >
                  True
                </a>
                <a
                  onClick={() => {
                    setIsVerified(false);
                  }}
                >
                  False
                </a>
              </div>
            </div> */}
            <Button
              variant="contained"
              sx={{ ml: 1, my: 2 }}
              color="info"
              className={Dropdown.dropbtn}
              onClick={() => setOpenRegister(true)}
            >
              Create Publisher
            </Button>
          </section>
        </section>
        {nodata && !coupons.length == 0 && <section>Loading...</section>}

        <TableContainer
          component={Paper}
          elevation={0}
          sx={{
            bgcolor: "#fff",
            width: "100%",
            overflowX: "auto",
            overflowY: "visible",
          }}
        >
          <Table stickyHeader size="small" sx={{ minWidth: 2140 }}>
            <TableHead>
              <TableRow>
                <TableCell sx={publisherHeaderCellSx}>S. No.</TableCell>
                <TableCell sx={publisherHeaderCellSx}>ID</TableCell>
                <TableCell sx={publisherHeaderCellSx}>Name</TableCell>
                <TableCell sx={publisherHeaderCellSx}>Email</TableCell>
                <TableCell sx={publisherHeaderCellSx}>Is Required Mobile</TableCell>
                <TableCell sx={publisherHeaderCellSx}>Cashback Allowed</TableCell>
                <TableCell sx={publisherHeaderCellSx}>Default Voucher List</TableCell>
                <TableCell sx={publisherHeaderCellSx}>Voucher Types</TableCell>
                <TableCell sx={publisherHeaderCellSx}>Edit Voucher Type</TableCell>
                <TableCell sx={publisherHeaderCellSx}>Link Category</TableCell>
                <TableCell sx={publisherHeaderCellSx}>Change Password</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {coupons.map((row, index) => {
                const cashbackType = row?.cashback_allowed_type ?? 0;
                const cashbackLabel =
                  row?.cashback_allowed_label ||
                  getCashbackAllowedLabel(cashbackType);
                const isDefaultList = !!row?.is_default_voucher_list;
                const types = row?.category_type || [];

                return (
                  <TableRow key={`${row?._id ?? "row"}-${index}`}>
                    <TableCell>{index + 1}</TableCell>
                    <TableCell sx={{ maxWidth: 280, wordBreak: "break-all" }}>
                      {row?._id}
                    </TableCell>
                    <TableCell>{row?.name}</TableCell>
                    <TableCell>{row?.email}</TableCell>
                    <TableCell>
                      <IconButton
                        sx={{ borderRadius: 2 }}
                        onClick={() => {
                          setIsPublisherId(row?._id);
                          setMobileStatus(!row?.required_mobile);
                          setOpen(true);
                        }}
                      >
                        {row?.required_mobile ? (
                          <Typography>True</Typography>
                        ) : (
                          <Typography color="primary">False</Typography>
                        )}
                      </IconButton>
                    </TableCell>
                    <TableCell>
                      <IconButton
                        sx={{ borderRadius: 2 }}
                        onClick={() => {
                          setIsPublisherId(row?._id);
                          setCashbackAllowedType(cashbackType);
                          setOpenCashback(true);
                        }}
                      >
                        <Typography color="primary">{cashbackLabel}</Typography>
                      </IconButton>
                    </TableCell>
                    <TableCell>
                      <IconButton
                        sx={{ borderRadius: 2 }}
                        onClick={() => {
                          setIsPublisherId(row?._id);
                          setDefaultVoucherListStatus(!isDefaultList);
                          setOpenDefaultVoucherList(true);
                        }}
                      >
                        {isDefaultList ? (
                          <Typography>Default</Typography>
                        ) : (
                          <Typography color="primary">Custom</Typography>
                        )}
                      </IconButton>
                    </TableCell>
                    <TableCell>
                      {!types.length ? (
                        <Typography color="text.secondary">—</Typography>
                      ) : (
                        <Box
                          sx={{
                            display: "flex",
                            flexWrap: "wrap",
                            gap: 0.5,
                            py: 0.5,
                          }}
                        >
                          {types.map((id, chipIndex) => {
                            const cat = categories.find((c) => c._id === id);
                            return (
                              <Chip
                                key={`${id}-${chipIndex}`}
                                size="small"
                                label={cat ? cat.name : id}
                              />
                            );
                          })}
                        </Box>
                      )}
                    </TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        onClick={() => {
                          setOpenCategory(true);
                          setSelectedPublisherId(row?._id);
                          const selectedObjs = row?.category_type
                            ?.map((id) => categories.find((c) => c._id === id))
                            .filter(Boolean);
                          setSelectedCategories(selectedObjs);
                        }}
                      >
                        Edit
                      </Button>
                    </TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        onClick={() => {
                          setLinkCategoryPublisherId(row?._id);
                          setLinkCategoryForm(emptyLinkCategoryForm);
                          setEditingCategoryId(null);
                          setLinkCategoryIsDeleted(false);
                          setOpenLinkCategory(true);
                          fetchPublisherCategories(row?._id, false);
                        }}
                      >
                        Link Category
                      </Button>
                    </TableCell>
                    <TableCell>
                      <Button
                        variant="contained"
                        onClick={() => {
                          setChangePasswordData({
                            ...changePasswordData,
                            email: row?.email,
                          });
                          setOpenPassword(true);
                        }}
                      >
                        Change Password
                      </Button>
                    </TableCell>
                  </TableRow>
                );
              })}
            </TableBody>
          </Table>
        </TableContainer>
      </section>

      {coupons.length > 0 && !isMore && (
        <Button
          variant="contained"
          sx={{ ml: 1, my: 2 }}
          color="info"
          onClick={Showmore}
        >
          More
        </Button>
      )}

      <Modal
        open={openPassword}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Change Password
          </Typography>

          {/* Input Fields */}
          <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 2 }}>
            <TextField
              label="Email"
              name="email"
              value={changePasswordData?.email}
              // onChange={handleChange}
              fullWidth
            />
            <TextField
              type="password"
              label="Password"
              name="password"
              value={changePasswordData?.password}
              onChange={(e) => {
                setChangePasswordData({
                  ...changePasswordData,
                  password: e?.target?.value,
                });
              }}
              fullWidth
            />

            <TextField
              type="password"
              label="Confirm Password"
              name="c_password"
              value={changePasswordData?.c_password}
              onChange={(e) => {
                setChangePasswordData({
                  ...changePasswordData,
                  c_password: e?.target?.value,
                });
              }}
              fullWidth
            />
          </Box>

          {/* Action Buttons */}
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", mt: 3, gap: 2 }}
          >
            <Button onClick={() => setOpenPassword(false)}>Cancel</Button>
            <Button variant="contained" onClick={handleChangePassWord}>
              Change
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={open}
        onClose={() => setOpen(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Are you Sure you want to Change Mobile Status?
          </Typography>
          <Typography id="modal-modal-description" sx={{ mt: 2 }}>
            <Button
              onClick={() => {
                changeMobileRequreStaus();
              }}
            >
              Yes
            </Button>
            <Button>No</Button>
          </Typography>
        </Box>
      </Modal>

      <Modal
        open={openDefaultVoucherList}
        onClose={() => setOpenDefaultVoucherList(false)}
        aria-labelledby="default-voucher-list-modal-title"
        aria-describedby="default-voucher-list-modal-description"
      >
        <Box sx={style}>
          <Typography
            id="default-voucher-list-modal-title"
            variant="h6"
            component="h2"
          >
            {defaultVoucherListStatus
              ? "Set voucher list as Default list?"
              : "Set voucher list as Custom list?"}
          </Typography>
          <Typography
            id="default-voucher-list-modal-description"
            sx={{ mt: 2 }}
          >
            <Button onClick={changeDefaultVoucherList}>Yes</Button>
            <Button onClick={() => setOpenDefaultVoucherList(false)}>No</Button>
          </Typography>
        </Box>
      </Modal>

      <Modal
        open={openCashback}
        onClose={() => setOpenCashback(false)}
        aria-labelledby="cashback-modal-title"
        aria-describedby="cashback-modal-description"
      >
        <Box sx={style}>
          <Typography id="cashback-modal-title" variant="h6" component="h2">
            Change Cashback Allowed Type
          </Typography>
          <FormControl fullWidth sx={{ mt: 2 }}>
            <InputLabel id="cashback-allowed-label">Cashback Allowed</InputLabel>
            <Select
              labelId="cashback-allowed-label"
              label="Cashback Allowed"
              value={cashbackAllowedType}
              onChange={(e) => setCashbackAllowedType(e.target.value)}
            >
              {CASHBACK_ALLOWED_OPTIONS.map((option) => (
                <MenuItem key={option.value} value={option.value}>
                  {option.label}
                </MenuItem>
              ))}
            </Select>
          </FormControl>
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", mt: 3, gap: 2 }}
          >
            <Button onClick={() => setOpenCashback(false)}>Cancel</Button>
            <Button variant="contained" onClick={changeCashbackAllowedType}>
              Save
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={openRegister}
        onClose={() => setOpenRegister(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Register Publisher
          </Typography>

          {/* Input Fields */}
          <Box sx={{ mt: 2, display: "flex", flexDirection: "column", gap: 2 }}>
            <TextField
              label="Name"
              name="name"
              value={formData.name}
              onChange={handleChange}
              fullWidth
            />
            <TextField
              label="Email"
              name="email"
              value={formData.email}
              onChange={handleChange}
              fullWidth
            />
            <TextField
              label="Mobile"
              name="mobile"
              value={formData.mobile}
              onChange={handleChange}
              fullWidth
            />
            {/* <TextField
              label="App Key"
              name="app_key"
              value={formData.app_key}
              onChange={handleChange}
              fullWidth
            />
            <TextField
              label="Secret Key"
              name="secret_key"
              value={formData.secret_key}
              onChange={handleChange}
              fullWidth
            /> */}
            <TextField
              type="password"
              label="Password"
              name="password"
              value={formData.password}
              onChange={handleChange}
              fullWidth
            />
            <TextField
              type="password"
              label="Confirm Password"
              name="c_password"
              value={formData.c_password}
              onChange={handleChange}
              fullWidth
            />
          </Box>

          {/* Action Buttons */}
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", mt: 3, gap: 2 }}
          >
            <Button onClick={() => setOpenRegister(false)}>Cancel</Button>
            <Button variant="contained" onClick={handleSubmit}>
              Register
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={openLinkCategory}
        onClose={() => {
          setOpenLinkCategory(false);
          setLinkCategoryIsDeleted(false);
          resetLinkCategoryForm();
        }}
        aria-labelledby="link-category-modal-title"
        aria-describedby="link-category-modal-description"
      >
        <Box sx={linkCategoryModalStyle}>
          <Typography id="link-category-modal-title" variant="h6" component="h2">
            Link Category
          </Typography>

          <Box
            sx={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
              mt: 2,
              mb: 1,
            }}
          >
            <Typography variant="subtitle2">Publisher Categories</Typography>
            <FormControl size="small" sx={{ minWidth: 140 }}>
              <InputLabel id="link-category-deleted-label">Is Deleted</InputLabel>
              <Select
                labelId="link-category-deleted-label"
                label="Is Deleted"
                value={linkCategoryIsDeleted ? "true" : "false"}
                onChange={(e) => {
                  const next = e.target.value === "true";
                  setLinkCategoryIsDeleted(next);
                  resetLinkCategoryForm();
                  fetchPublisherCategories(linkCategoryPublisherId, next);
                }}
              >
                <MenuItem value="false">False</MenuItem>
                <MenuItem value="true">True</MenuItem>
              </Select>
            </FormControl>
          </Box>

          {loadingPublisherCategories ? (
            <Box sx={{ display: "flex", justifyContent: "center", py: 2 }}>
              <CircularProgress size={28} />
            </Box>
          ) : publisherCategories.length > 0 ? (
            <Box
              sx={{
                maxHeight: 220,
                overflowY: "auto",
                border: "1px solid #e0e0e0",
                borderRadius: 1,
              }}
            >
              {publisherCategories.map((category) => {
                const isCategoryDeleted =
                  category.is_deleted || linkCategoryIsDeleted;
                return (
                  <Box
                    key={category._id}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      gap: 1,
                      px: 2,
                      py: 1.5,
                      borderBottom: "1px solid #f0f0f0",
                      bgcolor:
                        editingCategoryId === category._id
                          ? "action.selected"
                          : "transparent",
                      "&:last-child": { borderBottom: 0 },
                    }}
                  >
                    <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
                      {category.image ? (
                        <Avatar
                          src={category.image}
                          alt={category.name}
                          sx={{ width: 28, height: 28 }}
                        />
                      ) : null}
                      <Box>
                        <Typography variant="body2">
                          {category.name}
                          {category.is_popular_category ? " ⭐" : ""}
                        </Typography>
                        <Typography variant="body2" color="text.secondary">
                          Position: {category.position} | Cashback:{" "}
                          {category.cashback_percentage ?? 0}%
                          {category.is_popular_category ? " | Popular" : ""}
                        </Typography>
                      </Box>
                    </Box>
                    <Box sx={{ display: "flex", alignItems: "center", gap: 0.5 }}>
                      {!isCategoryDeleted && (
                        <Button
                          size="small"
                          variant="outlined"
                          onClick={() => handleEditPublisherCategory(category)}
                        >
                          Edit
                        </Button>
                      )}
                      {isCategoryDeleted ? (
                        <IconButton
                          size="small"
                          onClick={() =>
                            handleDeleteOrRestorePublisherCategory(
                              category,
                              false
                            )
                          }
                          title="Restore"
                        >
                          <RestoreFromTrashIcon color="success" />
                        </IconButton>
                      ) : (
                        <IconButton
                          size="small"
                          onClick={() =>
                            handleDeleteOrRestorePublisherCategory(
                              category,
                              true
                            )
                          }
                          title="Delete"
                        >
                          <DeleteIcon color="error" />
                        </IconButton>
                      )}
                    </Box>
                  </Box>
                );
              })}
            </Box>
          ) : (
            <Typography variant="body2" color="text.secondary" sx={{ py: 1 }}>
              No categories found for this publisher.
            </Typography>
          )}

          <Divider sx={{ my: 2 }} />

          <Typography variant="subtitle2" sx={{ mb: 1 }}>
            {editingCategoryId ? "Update Category" : "Create New Category"}
          </Typography>
          <Box sx={{ display: "flex", flexDirection: "column", gap: 2 }}>
            <TextField
              label="Category Name"
              name="name"
              value={linkCategoryForm.name}
              onChange={(e) =>
                setLinkCategoryForm({
                  ...linkCategoryForm,
                  name: e.target.value,
                })
              }
              fullWidth
            />
            <TextField
              label="Position"
              name="position"
              type="number"
              value={linkCategoryForm.position}
              onChange={(e) =>
                setLinkCategoryForm({
                  ...linkCategoryForm,
                  position: e.target.value,
                })
              }
              fullWidth
            />
            <TextField
              label="Cashback Percentage"
              name="cashback_percentage"
              type="number"
              value={linkCategoryForm.cashback_percentage}
              onChange={(e) =>
                setLinkCategoryForm({
                  ...linkCategoryForm,
                  cashback_percentage: e.target.value,
                })
              }
              fullWidth
            />
            <FormControlLabel
              control={
                <Checkbox
                  checked={!!linkCategoryForm.is_popular_category}
                  onChange={(e) =>
                    setLinkCategoryForm({
                      ...linkCategoryForm,
                      is_popular_category: e.target.checked,
                    })
                  }
                />
              }
              label="Mark as Popular Category"
            />
            <label htmlFor="publisher-category-image">
              <input
                accept="image/*"
                id="publisher-category-image"
                type="file"
                onChange={handleLinkCategoryImageUpload}
                style={{ display: "none" }}
              />
              <Button variant="contained" component="span" color="info">
                Upload Image
              </Button>
            </label>
            {linkCategoryForm.image ? (
              <img
                src={linkCategoryForm.image}
                width="50px"
                alt="category"
              />
            ) : null}
          </Box>
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", mt: 3, gap: 2 }}
          >
            <Button
              onClick={() => {
                if (editingCategoryId) {
                  resetLinkCategoryForm();
                } else {
                  setOpenLinkCategory(false);
                }
              }}
            >
              {editingCategoryId ? "Cancel Edit" : "Cancel"}
            </Button>
            <Button
              variant="contained"
              onClick={
                editingCategoryId
                  ? handleUpdatePublisherCategory
                  : handleCreatePublisherCategory
              }
            >
              {editingCategoryId ? "Update" : "Create"}
            </Button>
          </Box>
        </Box>
      </Modal>

      <Modal
        open={openCategory}
        onClose={() => setOpenCategory(false)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={style}>
          <Typography id="modal-modal-title" variant="h6" component="h2">
            Add Voucher Type
          </Typography>
          <Autocomplete
            multiple
            options={categories}
            disableCloseOnSelect
            getOptionLabel={(option) => option.name}
            value={selectedCategories}
            onChange={(event, newValue) => setSelectedCategories(newValue)}
            isOptionEqualToValue={(option, value) => option._id === value._id} // 👈 important
            renderOption={(props, option) => (
              <Box component="li" sx={{ display: "flex", alignItems: "center", gap: 1 }} {...props}>
                <Avatar src={option.image} alt={option.name} sx={{ width: 30, height: 30 }} />
                {option.name}
              </Box>
            )}
            renderTags={(value, getTagProps) =>
              value.map((option, index) => (
                <Chip
                  key={option._id}
                  label={option.name}
                  {...getTagProps({ index })}
                />
              ))
            }
            renderInput={(params) => <TextField {...params} label="Select Categories" />}
            sx={{ mt: 2 }}
          />
          <Box
            sx={{ display: "flex", justifyContent: "flex-end", mt: 3, gap: 2 }}
          >
            <Button onClick={() => setOpenCategory(false)}>Cancel</Button>
            <Button
              variant="contained"
              onClick={() => handleSubmitCategory(selectedCategories)}
            >
              Add
            </Button>
          </Box>
        </Box>
      </Modal>
    </>
  );
}

export default Publihser;
